var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "upsell-cart" },
    [
      _c(
        "section",
        { staticClass: "upsell-cart-header" },
        [
          _c("SaasIcon", {
            attrs: { icon: "svgLogoSellsyText", width: "118", height: "28" }
          }),
          _vm._v(" "),
          _c(
            "CompassLink",
            {
              attrs: {
                type: "secondary",
                prefixIcon: "caret-left",
                size: "small",
                label: ""
              },
              on: { click: _vm.goToPrevious }
            },
            [
              _c(
                "span",
                { staticClass: "typographies-paragraph-medium-semibold" },
                [_vm._v(_vm._s(_vm.$l10n.__("Retour")))]
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.loading
        ? [
            _c(
              "section",
              { class: ["upsell-cart-settings", _vm.settingClasses] },
              [
                _c(
                  "h1",
                  {
                    staticClass:
                      "typographies-display-large upsell-cart-settings__heading"
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.title) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.getIsPricingVersion3
                  ? _c("ChargebeeUpsellConfigPV3", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.step === 0,
                          expression: "step === 0"
                        }
                      ]
                    })
                  : _c("ChargebeeUpsellConfig", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.step === 0,
                          expression: "step === 0"
                        }
                      ]
                    }),
                _vm._v(" "),
                _c("ChargebeeUpsellSettingsSummary", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.step > 0,
                      expression: "step > 0"
                    }
                  ],
                  staticClass: "upsell-cart-summary"
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "upsell-cart-payment-summary" },
              [
                _c(
                  "h2",
                  {
                    staticClass:
                      "upsell-cart-payment-summary__heading typographies-display-small"
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.paymentSummaryHeading) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("ChargebeeUpsellPaymentSummary", {
                  staticClass: "upsell-cart-payment-summary__container",
                  attrs: { step: _vm.step }
                }),
                _vm._v(" "),
                _vm.step > 0
                  ? _c(
                      "div",
                      { staticClass: "upsell-cart-payment-summary-method" },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "typographies-paragraph-medium-semibold"
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$l10n.__("Payé via")) +
                                "\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "div",
                              {
                                class: [
                                  "card",
                                  {
                                    "card--is-invalid":
                                      _vm.hasErrorPaymentMethod
                                  }
                                ]
                              },
                              [
                                _c("SaasIcon", {
                                  attrs: {
                                    icon: _vm.paymentMethodIcon,
                                    width: 24,
                                    height: _vm.isSEPAPaymentMethod ? 18 : 16
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "typographies-paragraph-medium-regular"
                                  },
                                  [
                                    _vm.isCardPaymentMethod
                                      ? [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.$l10n.__(
                                                  "finissant par " +
                                                    _vm.getPaymentMethodData
                                                      .last4
                                                )
                                              ) +
                                              "\n                            "
                                          )
                                        ]
                                      : _vm.isSEPAPaymentMethod
                                      ? [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(_vm.$l10n.__("SEPA")) +
                                              "\n                            "
                                          )
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("CompassButton", {
                              attrs: {
                                label: _vm.$t.__("common.actions.edit"),
                                type: "tertiary"
                              },
                              on: { click: _vm.openCbPortalSection }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasError
                  ? _c("CompassAlert", {
                      attrs: {
                        type: "error",
                        description: _vm.errorMsg,
                        "show-close": false
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "CompassTooltip",
                  {
                    attrs: {
                      content: _vm.$t.__(
                        "pages.account.upsell.ChargebeeUpsellCart.update_subscription_to_continue"
                      ),
                      "content-class": "typographies-paragraph-small-regular",
                      disabled: _vm.canNextStep,
                      placement: "bottom"
                    }
                  },
                  [
                    _c("CompassButton", {
                      staticClass:
                        "upsell-cart-payment-summary-confirm__button",
                      attrs: {
                        label: _vm.nextStepButtonLabel,
                        disabled: !_vm.canNextStep,
                        loading: _vm.getEstimationLoading
                      },
                      on: { click: _vm.nextStep }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.step > 0
                  ? _c("CompassButton", {
                      staticClass: "upsell-cart-payment-summary-cancel__button",
                      attrs: {
                        type: "secondary",
                        label: _vm.$t.__("common.actions.cancel"),
                        loading: _vm.getEstimationLoading
                      },
                      on: { click: _vm.goToAccountPreferences }
                    })
                  : _vm._e()
              ],
              1
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.displayPreload
        ? [_c("preloader", { attrs: { display: true } })]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }